import { configureStore } from "@reduxjs/toolkit";
// auth
import loginSlicer from "./custom-actions/auth/login-actions/LoginSlicer";
import logoutSlicer from "./custom-actions/auth/logout-actons/LogoutSlicer";
import refreshTokenSlicer from "./custom-actions/auth/RefreshTokenSlicer";

import mediaReducer from "./custom-actions/mediaSlice";
// products
import getAllProductsSlicer from "./custom-actions/products-actions/GetProductsSlicer";
import addProductSlicer from "./custom-actions/products-actions/AddProductSlicer";
import deleteProductSlicer from "./custom-actions/products-actions/DeleteProductSlicer";
import getSingleProductSlicer from "./custom-actions/products-actions/GetSingleProductSlicer";
import updateProductSlicer from "./custom-actions/products-actions/UpdateProductSlicer";
import bulkDeleteSlicer from "./custom-actions/products-actions/BulkDeleteSlicer";
import bulkUpdateProductsSlicer from "./custom-actions/products-actions/BulkUpdateProductsSlicer";
import duplicateProductSlicer from "./custom-actions/products-actions/DuplicateProductSlicer";
import exportProductsSlicer from "./custom-actions/products-actions/ExportProductsSlicer";
import importProductsSlicer from "./custom-actions/products-actions/ImportProductsSlicer";

// categories
import getCategoriesSlicer from "./custom-actions/categories-actions/GetCategoriesSlicer";
import addCategorySlicer from "./custom-actions/categories-actions/AddCategorySlicer";
import deleteCategorySlicer from "./custom-actions/categories-actions/DeleteCategoriesSlicer";
import updateCategorySlicer from "./custom-actions/categories-actions/UpdateCategorySlicer";
import getSingleCategorySlicer from "./custom-actions/categories-actions/GetSingleCategorySlicer";

// countries
import getCountriesSlicer from "./custom-actions/countries-actions/GetContriesSlicer";
import addCountrySlicer from "./custom-actions/countries-actions/AddCountryFunc";
import getSingleCountrySlicer from "./custom-actions/countries-actions/GetSingleCountrySlicer";
import deleteCountrySlicer from "./custom-actions/countries-actions/DeleteCountrySlicer";
import updateCountrySlicer from "./custom-actions/countries-actions/UpdateCountrySlicer";

// cities
import getCitiesSlicer from "./custom-actions/cities-actions/GetCitiesSlicer";
import addCitySlicer from "./custom-actions/cities-actions/AddCitySlicer";
import getSingleCitySlicer from "./custom-actions/cities-actions/GetSingleCitySlicer";
import updateCitySlicer from "./custom-actions/cities-actions/UpdateCitySlicer";
import deleteCitySlicer from "./custom-actions/cities-actions/DeleteCitySlicer";

//states
import getStatesSlicer from "./custom-actions/states-actions/GetStatesSlicer";
import addStateSlicer from "./custom-actions/states-actions/AddStateSlicer";
import getSingleStateSlicer from "./custom-actions/states-actions/GetSingleStateSlicer";
import updateStateSlicer from "./custom-actions/states-actions/UpdateStateSlicer";
import deleteStateSlicer from "./custom-actions/states-actions/DeleteStateSlicer";

//copons
import getCouponsSlicer from "./custom-actions/coupons-actions/GetCouponsSlicer";
import addCouponSlicer from "./custom-actions/coupons-actions/AddCouponSlicer";
import deleteCouponSlicer from "./custom-actions/coupons-actions/DeleteCouponSlicer";
import updateCouponSlicer from "./custom-actions/coupons-actions/UpdateCouponSlicer";
import getSingleCouponSlicer from "./custom-actions/coupons-actions/GetSingleCouponSlicer";

//users
import getUsersSlicer from "./custom-actions/users-actions/GetUsersSlicer";
import getSingleUserSlicer from "./custom-actions/users-actions/GetSingleUserSlicer";
import deleteUserSlicer from "./custom-actions/users-actions/DeleteUserSlicer";
import updateUserSlicer from "./custom-actions/users-actions/UpdateUserSlicer";

//roles
import getRolesSlicer from "./custom-actions/roles-actions/GetRolesSlicer";
import getSingleRoleSlicer from "./custom-actions/roles-actions/GetSingleRoleSlicer";
import addRoleSlicer from "./custom-actions/roles-actions/AddRoleSlicer";
import updateRoleSlicer from "./custom-actions/roles-actions/UpdateRoleSlicer";
import deleteRoleSlicer from "./custom-actions/roles-actions/DeleteRoleSlicer";

//permissions
import getPermissionsSlicer from "./custom-actions/permissions-actions/GetPermissionsSlicer";

//admins
import getAdminsSicer from "./custom-actions/admins-actions/GetAdminsSlicer";
import updateAdminSlicer from "./custom-actions/admins-actions/UpdateAdminSlicer";
import addAdminSlicer from "./custom-actions/admins-actions/AddAdminSlicer";
import getSingleAdminSlicer from "./custom-actions/admins-actions/GetSingleAdminSlicer";
import changeAdminPassSlicer from "./custom-actions/admins-actions/ChangeAdminPassSlicer";
import updateAdminImageSlicer from "./custom-actions/admins-actions/UpdateAdminImageSlicer";
import deleteAdminSlicer from "./custom-actions/admins-actions/DeleteAdminSlicer";
import getProfileDataSlicer from "./custom-actions/admins-actions/GetProfleDataSlicer";

//orders
import ordersSlicer from "./custom-actions/orders-actions/ordersSlicer";
import getOrdersSlicer from "./custom-actions/orders-actions/GetOrdersSlicer";
import getSingleOrderSlicer from "./custom-actions/orders-actions/GetSingleOrderSlicer";
import updateOrderSlicer from "./custom-actions/orders-actions/UpdateOrderSlicer";
import updateOrderRefundSlicer from "./custom-actions/orders-actions/UpdateOrderSlicer";
import deleteOrderSlicer from "./custom-actions/orders-actions/DeleteOrderSlicer";
import exportOredersSlicer from "./custom-actions/orders-actions/ExportOredersSlicer";

//news letters
import getNewsLettersSlicer from "./custom-actions/news-letters-actions/GetNewsLettersSlicer";
import addNewEmailSlicer from "./custom-actions/news-letters-actions/AddNewEmailSlicer";
import postNewMessageSlicer from "./custom-actions/news-letters-actions/PostNewMessageSlicer";
import verifyEmailSlicer from "./custom-actions/news-letters-actions/VerifyEmailSlicer";
import deleteEmailSlicer from "./custom-actions/news-letters-actions/DeleteEmailSlicer";

//settings
import siteSettingsSlicer from "./custom-actions/settings-actions/siteSettingsSlicer";
import getBasicSettingsSlicer from "./custom-actions/settings-actions/basic-settings/GetBasicSettingsSlicer";
import postBasicSettingsSlicer from "./custom-actions/settings-actions/basic-settings/PostBasicSettingsSlicer";
import getGeneralSettingsSlicer from "./custom-actions/settings-actions/general-settings/GetGeneralSettingsSlicer";
//smtp
import getSmtpSettingsSlicer from "./custom-actions/settings-actions/smtp/GetSmtpSettingsSlicer";
import postSmtpSettingsSlicer from "./custom-actions/settings-actions/smtp/PostSmtpSettingsSlicer";
import testSmtpSettingsSlicer from "./custom-actions/settings-actions/smtp/TestSmtpSettingsSlicer";
//oto-settings
import getOtoSettingsSlicer from "./custom-actions/settings-actions/oto-settings/GetOtoSettingsSlicer";
import postOtoSettingsSlicer from "./custom-actions/settings-actions/oto-settings/PostOtoSettingsSlicer";
import testOtoConnectionSlicer from "./custom-actions/settings-actions/oto-settings/TestOtoConnectionSlicer";
//paymnet
import getPaymentSettingsSlicer from "./custom-actions/settings-actions/payment-gateway-settings/GetPaymentSettingsSlicer";
import postPaymentSettingsSlicer from "./custom-actions/settings-actions/payment-gateway-settings/PostPaymentSettingsSlicer";
import getHomeDataSlicer from "./custom-actions/settings-actions/dahsboard/GetHomeDataSlicer";
import getSiteDataSlicer from "./custom-actions/settings-actions/dahsboard/GetSiteDataSlicer";

//sliders
import getSlidersSlicer from "./custom-actions/sliders/GetSlidersSlicer";
import getSingleSliderSlicer from "./custom-actions/sliders/GetSingleSliderSlicer";
import addNewSliderSlicer from "./custom-actions/sliders/AddSliderSlicer";
import updateSliderSlicer from "./custom-actions/sliders/UpdateSliderSlicer";
import deleteSliderSlicer from "./custom-actions/sliders/DeleteSliderSlicer";

//currencies
import getCurrenciesSlicer from "./custom-actions/currencies-actions/GetCurrenciesSlicer";
import addCurrencySlicer from "./custom-actions/currencies-actions/AddCurrencySlicer";
import updateCurrencySlicer from "./custom-actions/currencies-actions/UpdateCurrencySlicer";
import deleteCurrencySlicer from "./custom-actions/currencies-actions/DeleteCurrencySlicer";
import getSingleCurrencySlicer from "./custom-actions/currencies-actions/GetSingleCurrencySlicer";
import setDefaultCurrencySlicer from "./custom-actions/currencies-actions/SetDefaultCurrencySlicer";

//notfications
import getNotficationSlicer from "./custom-actions/notfications-actions/GetNotficationSlicer";
import readAllNotficationsSlicer from "./custom-actions/notfications-actions/ReadAllNotficationsSlicer";
import sendNotficationSlicer from "./custom-actions/notfications-actions/SendNotficationSlicer";

//contact
import readMessageSlicer from "./custom-actions/contact-actions/ReadMessageSlicer";
import getContactsSlicer from "./custom-actions/contact-actions/GetContactsSlicer";
import deleteContactSlicer from "./custom-actions/contact-actions/DeleteContactSlicer";

//whatsapp
import postWhatsappMessageSlicer from "./custom-actions/whatsapp-actions/PostWhatsappMessageSlicer";

//languages
import getLanguageSlicer from "./custom-actions/language/GetLanguagesSlicer";
import getSingleLanguageSlicer from "./custom-actions/language/GetSingleLanguageSlicer";
import translateTextSlicer from "./custom-actions/language/TranslateTextSlicer";
import newTranslateTextSlicer from "./custom-actions/language/NewTranslateTextSlicer";
import addNewLanguageSlicer from "./custom-actions/language/AddNewLanguageSlicer";
import makeLangDefaultSlicer from "./custom-actions/language/MakeLangDefaultSlicer";
import autoTranslateLanguageSlicer from "./custom-actions/language/AutoTranslateLanguageSlicer";
import deleteLanguageSlicer from "./custom-actions/language/DeleteLanguageSlicer";
import getAppLanguageSlicer from "./custom-actions/language-settings/GetAppLanguageSlicer";
import getLanguageSettingsSlicer from "./custom-actions/language/GetLanguageSettingsSlicer";

//images
import getSiteImagesSlicer from "./custom-actions/images/GetSiteImagesSlicer";
import addImagesToStorageSlicer from "./custom-actions/images/AddImagesToStorageSlicer";

//attributes
import attributeValuesSlicer from "./custom-actions/attributes-actions/attributeValuesSlicer";
import getAttributesSlicer from "./custom-actions/attributes-actions/GetAttributesSlicer";
import getAttributeSlicer from "./custom-actions/attributes-actions/GetAttributeSlicer";
import updateAttributeSlicer from "./custom-actions/attributes-actions/UpdateAttributeSlicer";
import createAttributeValueSlicer from "./custom-actions/attributes-actions/CreateAttributeValueSlicer";
import createAttributeSlicer from "./custom-actions/attributes-actions/CreateAttributeSlicer";
import deleteAttributeValueSlicer from "./custom-actions/attributes-actions/DeleteAttributeValueSlicer";

//partners
import getPartnersSlicer from "./custom-actions/partners-actions/GetPartnersSlicer";
import addPartnerSlicer from "./custom-actions/partners-actions/AddPartnerSlicer";
import updatePartnerSlicer from "./custom-actions/partners-actions/UpdatePartnerSlicer";
import deletePartnerSlicer from "./custom-actions/partners-actions/DeletePartnerSlicer";
import getSinglePartnerSlicer from "./custom-actions/partners-actions/GetSinglePartnerSlicer";

export const CustomStore = configureStore({
  reducer: {
    loginSlicer,
    logoutSlicer,
    refreshTokenSlicer,
    media: mediaReducer,
    // products slicer
    getAllProductsSlicer,
    addProductSlicer,
    deleteProductSlicer,
    getSingleProductSlicer,
    updateProductSlicer,
    bulkDeleteSlicer,
    bulkUpdateProductsSlicer,
    duplicateProductSlicer,
    exportProductsSlicer,
    importProductsSlicer,

    //categories
    getCategoriesSlicer,
    addCategorySlicer,
    deleteCategorySlicer,
    updateCategorySlicer,
    getSingleCategorySlicer,

    //countries
    getCountriesSlicer,
    getSingleCountrySlicer,
    deleteCountrySlicer,
    updateCountrySlicer,
    addCountrySlicer,

    //cities
    getCitiesSlicer,
    addCitySlicer,
    getSingleCitySlicer,
    updateCitySlicer,
    deleteCitySlicer,

    //states
    getStatesSlicer,
    addStateSlicer,
    getSingleStateSlicer,
    updateStateSlicer,
    deleteStateSlicer,

    //coupons
    addCouponSlicer,
    deleteCouponSlicer,
    getCouponsSlicer,
    updateCouponSlicer,
    getSingleCouponSlicer,

    //users
    getUsersSlicer,
    getSingleUserSlicer,
    deleteUserSlicer,
    updateUserSlicer,

    //roles
    getRolesSlicer,
    getSingleRoleSlicer,
    updateRoleSlicer,
    addRoleSlicer,
    deleteRoleSlicer,
    //permissions
    getPermissionsSlicer,

    //admins
    getAdminsSicer,
    getSingleAdminSlicer,
    updateAdminSlicer,
    addAdminSlicer,
    changeAdminPassSlicer,
    updateAdminImageSlicer,
    deleteAdminSlicer,
    getProfileDataSlicer,

    //orders
    ordersSlicer,
    getOrdersSlicer,
    deleteOrderSlicer,
    getSingleOrderSlicer,
    updateOrderSlicer,
    updateOrderRefundSlicer,
    exportOredersSlicer,

    //news letters
    getNewsLettersSlicer,
    addNewEmailSlicer,
    postNewMessageSlicer,
    verifyEmailSlicer,
    deleteEmailSlicer,

    //settings
    siteSettingsSlicer,
    getBasicSettingsSlicer,
    postBasicSettingsSlicer,
    getGeneralSettingsSlicer,
    //smtp
    getSmtpSettingsSlicer,
    postSmtpSettingsSlicer,
    testSmtpSettingsSlicer,
    //oto-settings
    getOtoSettingsSlicer,
    postOtoSettingsSlicer,
    testOtoConnectionSlicer,
    //payment
    getPaymentSettingsSlicer,
    postPaymentSettingsSlicer,
    //home
    getHomeDataSlicer,
    getSiteDataSlicer,

    //notfications
    getNotficationSlicer,
    readAllNotficationsSlicer,
    sendNotficationSlicer,

    //contact
    readMessageSlicer,
    getContactsSlicer,
    deleteContactSlicer,

    //whatsapp
    postWhatsappMessageSlicer,

    //languages
    getLanguageSlicer,
    getSingleLanguageSlicer,
    translateTextSlicer,
    addNewLanguageSlicer,
    autoTranslateLanguageSlicer,
    makeLangDefaultSlicer,
    deleteLanguageSlicer,
    newTranslateTextSlicer,
    getAppLanguageSlicer,
    getLanguageSettingsSlicer,

    //sliders
    getSlidersSlicer,
    getSingleSliderSlicer,
    addNewSliderSlicer,
    updateSliderSlicer,
    deleteSliderSlicer,

    //currencies
    getCurrenciesSlicer,
    addCurrencySlicer,
    updateCurrencySlicer,
    deleteCurrencySlicer,
    getSingleCurrencySlicer,
    setDefaultCurrencySlicer,

    //images
    getSiteImagesSlicer,
    addImagesToStorageSlicer,

    //attributes
    attributeValuesSlicer,
    getAttributesSlicer,
    getAttributeSlicer,
    updateAttributeSlicer,
    createAttributeSlicer,
    createAttributeValueSlicer,
    deleteAttributeValueSlicer,

    //partners
    getPartnersSlicer,
    addPartnerSlicer,
    updatePartnerSlicer,
    deletePartnerSlicer,
    getSinglePartnerSlicer,
  },
});
